import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class MessageService {
    private _listners = new Subject<any>();

    listen(): Observable<any> {
        return this._listners.asObservable();
    }

    loadCurrentUserProfile() {
        this._listners.next();
    }
}



// WEBPACK FOOTER //
// ./src/services/message.service.ts